import React from "react"
import { MerchantCell } from "../shared/MerchantLabel"

const DOT = {
  RelationshipInstalled: "bg-emerald-500",
  RelationshipReactivated: "bg-emerald-500",
  SubscriptionChargeActivated: "bg-indigo-500",
  RelationshipUninstalled: "bg-red-500",
  SubscriptionChargeCanceled: "bg-red-500",
}

const relativeTime = (iso) => {
  const diffMs = Date.now() - new Date(iso).getTime()
  const mins = Math.round(diffMs / 60000)
  if (mins < 60) return `${mins}m`
  const hrs = Math.round(mins / 60)
  if (hrs < 24) return `${hrs}h`
  return `${Math.round(hrs / 24)}d`
}

// Lifecycle event stream. `labels` maps event type -> localized label; falls
// back to the raw type so an unknown event still renders.
export function RecentActivityFeed({ events, labels, emptyLabel, detailBasePath }) {
  if (!events || events.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">{emptyLabel}</p>
  }

  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-800">
      {events.map((event, i) => (
        <li key={`${event.shop}-${event.at}-${i}`} className="flex items-center gap-3 py-3">
          <span className={`h-2 w-2 shrink-0 rounded-full ${DOT[event.type] || "bg-gray-400 dark:bg-gray-600"}`} />
          <div className="min-w-0 flex-1">
            <MerchantCell name={event.name} shop={event.shop} merchantId={event.merchant_id} detailBasePath={detailBasePath} />
            <p className="text-xs text-gray-500 dark:text-gray-400">{labels[event.type] || event.type}</p>
          </div>
          <span className="shrink-0 text-xs text-gray-400 dark:text-gray-500">{relativeTime(event.at)}</span>
        </li>
      ))}
    </ul>
  )
}
